<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<div ref="contentBox" class="bs-content">
				<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/baseSalary/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/baseSalary/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEditClick()">新增</el-button></template>
			<el-form-item label="所属门店：">
						<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
							<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="员工姓名：">
						<el-input v-model="formInline.userName" placeholder="请输入员工姓名" clearable size="small" @change="inputChange"></el-input>
					</el-form-item>
			</lcsj-filter>
				<div ref="tableBox" class="bs-table-box">
					<STable ref="tableComp" :columns="columnsData" :data="listData" :loading="loading" :height="tableHeight" @row-db-click="handleEditClick">
						<template #userInfo.chName>
							<el-table-column label="员工姓名" width="100" align="center">
								<template #default="scope">
									<el-link type="primary" :underline="false" @click="handleShowHistory(scope.row)">
										{{ scope.row.userInfo.chName }}
									</el-link>
								</template>
							</el-table-column>
						</template>
						<template #operation>
							<el-table-column v-if="$checkBtnPermission('/baseSalary/index', 'create')" align="center" label="操作" width="100" fixed="right">
								<template #default="scope">
									<el-button size="mini" class="el-icon-edit" @click="handleEditClick(scope.row)">编辑</el-button>
								</template>
							</el-table-column>
						</template>
					</STable>
				</div>
				<div ref="pageBox" class="bs-page-box">
					<!-- 分页组件 -->
					<Pagination ref="pagination" v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
				</div>
			</div>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 历史记录 -->
		<history ref="history"></history>
	</div>
</template>

<script>
import { GetUserBaseSalaryPageList } from "@/api/salaryApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit.vue";
import history from "./history.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "基本工资"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			// 表格高度（数字 px）。el-table 只有拿到数字高度才会在内部竖向滚动；
			// 该值由 calcTableHeight 测量 .pd20 真实剩余空间后填入，与视口/表单高度无关。
			tableHeight: 600,
			// ResizeObserver 句柄
			ro: null,
			listData: [],
			selectionList: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				storeKeyId: "",
				userName: ""
			},
			storeList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					minWidth: "120",
					align: "center",
				},
				{
					slot: "userInfo.chName",
					label: "员工姓名",
					width: "100",
					align: "center",
				},
				{
					prop: "postName",
					label: "岗位",
					width: "110",
					align: "center",
				},
				{
					prop: "baseSalary",
					label: "基础薪资",
					width: "100",
					align: "center"
				},
				{
					prop: "postWage",
					label: "岗位薪资",
					width: "100",
					align: "center"
				},
				{
					prop: "socialSecuritySubsidy",
					label: "社保补贴",
					width: "100",
					align: "center"
				},
				{
					prop: "seniorityPay",
					label: "工龄补贴",
					width: "100",
					align: "center"
				},
				{
					prop: "requiredAttendance",
					label: "应出勤天数",
					width: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "100",
					align: "center",
					fixed: "right"
				}
			]
		};
	},
	// 注册组件
	components: {
		edit,
		history
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
	},
	mounted() {
		this.$nextTick(() => {
			this.calcTableHeight();
			// 容器尺寸变化（含窗口缩放）时实时重算表格高度，保证分页始终可见
			if (typeof ResizeObserver !== "undefined" && this.$refs.contentBox) {
				this.ro = new ResizeObserver(() => this.calcTableHeight());
				this.ro.observe(this.$refs.contentBox);
			}
		});
		window.addEventListener("resize", this.calcTableHeight);
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.calcTableHeight);
		if (this.ro) {
			this.ro.disconnect();
			this.ro = null;
		}
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 动态计算表格高度（测量真实剩余空间，数字 px）：
		// 内容区(bs-content) 填满 .pd20，表单与分页 flex-shrink:0 固定，
		// 表格容器 flex:1 吃掉剩余像素，量出后传给 el-table 触发内部竖滚，
		// 于是 .pd20 自身不出现滚动条，分页永远完整可见。与视口/表单高度无关。
		calcTableHeight() {
			this.$nextTick(() => {
				const content = this.$refs.contentBox;
				if (!content) return;
				const formEl = this.$refs.searchForm && this.$refs.searchForm.$el;
				const pageEl = this.$refs.pagination && this.$refs.pagination.$el;
				const formH = formEl ? formEl.offsetHeight : 0;
				const pageH = pageEl ? pageEl.offsetHeight : 0;
				// 双重保护：取 contentBox 和 .pd20 两者较小的 clientHeight，
				// 防止 flex 还没生效时量到被内容撑大的值。
				const pd20 = this.$refs.topTab && this.$refs.topTab.$el && this.$refs.topTab.$el.querySelector(".pd20");
				const contentH = pd20 ? Math.min(content.clientHeight, pd20.clientHeight) : content.clientHeight;
				// 24 = 表单下间距 + 表格与分页之间的安全余量（按钮行更高时也足够）
				const available = contentH - formH - pageH - 24;
				this.tableHeight = Math.max(200, Math.floor(available));
				// 关键：el-table 在 height prop 变化后不会自动按新高度重排，
				// 必须手动 doLayout，否则表格仍按旧高度渲染、内部不滚动、分页被推走。
				this.$nextTick(() => {
					const t = this.$refs.tableComp;
					if (t && typeof t.doLayoutTable === "function") t.doLayoutTable();
				});
			});
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetUserBaseSalaryPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
						// 数据回来后表格形态稳定，重算一次高度并强制 el-table 重排
						this.calcTableHeight();
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
				this.calcTableHeight();
			});
			this.getListData();
		},
		// 点击事件
		handleEditClick(row) {
			this.$refs.edit.editShow(row);
		},
		handleShowHistory(row) {
			this.$refs.history.showHistoryDialog(row.keyId, row.userInfo.chName);
		}
	}
};
</script>

<style scoped>
/* 内容区填满 .pd20（topTab 的 flex 列容器）。
   关键：flex:1 决定主轴尺寸 = 父容器高度；min-height:0 覆盖默认的 min-height:auto（=内容最小尺寸），
   避免被 15 行表格的内容最小尺寸撑高、超过 .pd20 导致 .pd20 滚动。
   overflow:hidden 兜底：万一 JS 还没量到正确高度，内容溢出也不会传递到 .pd20。 */
.bs-content {
	height: 100%;
	flex: 1 1 auto;
	min-height: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}
/* 表单固定不收缩 */
.bs-content .user-search {
	flex-shrink: 0;
}
/* 表格容器吃掉剩余空间（min-height:0 允许在 flex 中被压缩） */
.bs-table-box {
	flex: 1 1 auto;
	min-height: 0;
}
/* 分页固定不收缩，永远在容器内可见 */
.bs-page-box {
	flex-shrink: 0;
}
</style>
